module.exports = __webpack_public_path__ + "img/18.271ddf93.png";